<template>
    <div :class="rootCssClass" class="tag-select">
        <div class="selected product-tag" @click="open">

            <template v-if="selectedList.length || opened">
                <span v-for="it in selectedList" :key="it.key"
                      :class="{ disabled: it.disabled, }"
                      class="option item neutral"
                >
                    <span class="title">
                        <template v-if="it.item != null">
                            {{ it.title }}
                        </template>
                        <template v-else>
                            Unknown {{ it.key }}
                        </template>
                    </span>
                    <IconClose class="remove" @click="remove(it)" />
                </span>

                <input v-show="opened"
                       ref="search"
                       v-model="searchText"
                       class="search"
                       type="text"
                       @input="doSearch()"
                       @keydown.delete.stop="onDelete()"
                />
            </template>

            <template v-else>
                <span class="placeholder">{{ placeholder }}</span>
            </template>
        </div>

        <div v-show="opened" class="option-dialog">
            <div v-show="status === 'waiting'"
                 class="message waiting">
                <slot :searchText="searchText"
                      name="waiting"
                >Подождите, идет поиск...
                </slot>
            </div>

            <div v-show="status === 'failure'"
                 class="message failure">
                <slot :message="message"
                      :searchText="searchText"
                      name="failure"
                >{{ message }}
                </slot>
            </div>

            <div v-show="status === 'success'" class="container">
                <div v-show="needShowAppend"
                     class="append"
                     @click="doAppend()">
                    <slot :searchText="searchText"
                          name="append"
                    >Добавить объект «{{ searchText }}»
                    </slot>
                </div>

                <Node v-for="it in filteredRoot"
                      v-show="it.visible"
                      :key="it.key" :value="it"
                      :selectedMap="selectedMap"
                      :selectableGroups="selectableGroups"
                      :flatGroups="flatGroups"
                      @selected="toggle($event)"
                      @addSynonym="$emit('addSynonym', $event)">
                </Node>

                <div v-show="isEmpty"
                     class="message">
                    <slot :searchText="searchText"
                          name="absent"
                    >Ничего не найдено
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IconClose from '@/common/comp/selects/icons/close.svg?component';
import { ResetToEmpty, SearchMixin, SelectBase, VectorValueMixin } from '@dsee/components/selects/select.base.js';
import { tagKindsMap } from '@/common/page_comp/Tag/util.js';
import Node from './node.vector.vue';

export default {
    name: 'TagSelect',
    mixins: [ SelectBase, VectorValueMixin, SearchMixin, ResetToEmpty ],
    components: { IconClose, Node },
    methods: {
        async doAppend() {
            if (this.append == null)
                throw new Error('Append handler is not specified');

            const item = await this.append();

            if (item == null)
                return;

            const node = this.toInternal(item);
            this.$set(this.historyMap, node.key, node);

            this.select(node);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@dsee/mixins.scss';

.tag-select {
    @import '~@dsee/components/selects/select.base.scss';

    .selected {
        flex-wrap: wrap;
        padding: 0px 4px 4px 4px;

        & > * {
            margin-top: 4px;
        }

        & > .option:not(:last-of-type) {
            margin-right: 4px;
        }

        & > .placeholder {
            margin: 8px 8px 4px 8px;
        }

        & > .search {
            padding: 4px 8px;
            width: 60px;
        }

    }

    .selected > .option {
        flex: none;
        display: inline-flex;
        align-items: center;
        box-sizing: border-box;
        padding: 4px 8px;
        max-width: 100%;
        overflow: hidden;
        cursor: default;

        & > .title {
            flex: auto;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        & > .remove {
            @include icon(12px, 12px);
            margin-left: 4px;
            opacity: 0.5;
        }
    }

    .selected > .option.disabled,
    &.disabled .selected > .option {
        background: rgba(16, 24, 40, 0.05);

        & > .title {
            color: var(--input-disabled-color);
        }

        & > .remove {
            opacity: 0.25;
        }
    }
}
</style>
